import { getAxiosInstance } from '../client';
/** Mutation functions for offices */
export const officesMutations = {
    /** DELETE /offices/:id */
    delete: (officeId) => getAxiosInstance()
        .delete(`/offices/${officeId}`)
        .then((r) => r.data),
    /** POST /offices/open — „Praxis eröffnen“ for the session's Account (#1832). */
    open: (dto) => getAxiosInstance()
        .post('/offices/open', dto)
        .then((r) => r.data),
};
//# sourceMappingURL=offices.mutations.js.map